import { Injectable } from '@angular/core';
import { ResourceEffect } from '@app/core/store/effects/resource.effect';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SettingsActionTypes, LoadSettings, LoadSettingsSuccess } from '@dwo/actions';
import { SettingsService } from '@dwo/services';
import { State } from '@dwo/reducers';

@Injectable()
export class SettingsEffect extends ResourceEffect {
  constructor(
    readonly actions$: Actions,
    readonly settingsService: SettingsService,
    readonly store: Store<State>,
  ) {
    super(actions$, settingsService, store);
  }

  loadFeatures$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<LoadSettings>(SettingsActionTypes.LoadSettings),
        this.fetchResource('loadSettings', LoadSettingsSuccess),
      ),
  );
}
